/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */

import React, { useMemo, useEffect } from "react";
import get from "lodash/get";
import { InfiniteStoryBase, WithPreview } from "@quintype/components";
import { TextSTory } from "../story-templates/text-story/text-story";
import { number, object, shape, any } from "prop-types";
import { LiveBlog } from "../story-templates/live-blog/live-blog";
import { Listicle } from "../story-templates/listicle";
import { VideoStory } from "../story-templates/video-story";
import { Podcast } from "../story-templates/podcast";
import {LiveQA} from "../story-templates/live-qa"
import { storyFields } from "../../constants";
import { PhotoStory } from "../story-templates/photo-story";
import { useVerifyGiftStoryToken } from "../atoms/gift-story/useVerifyGiftStoryToken";
import { RelatedStories } from "../molecules/related-stories";

function StoryPageBase({ story, params, setLiveQA }) {
  const isGiftTokenValid = useVerifyGiftStoryToken(story);
  const memoizedStory = useMemo(() => ({ ...story, isAGiftStory: isGiftTokenValid }), [isGiftTokenValid]);

  const storyCopy = Object.assign({}, memoizedStory);
  const getFirstStoryCard = { cards: [memoizedStory && memoizedStory.cards && memoizedStory.cards[0]] };
  const newStory = Object.assign(storyCopy, getFirstStoryCard);

  useEffect(() => {
    const x = document.querySelectorAll(".story-element-text a");
    [...x].forEach(x => x.setAttribute("target", "_blank"));
  }, []);

  // Can switch to a different template based story-template, or only show a spoiler if index > 0
  switch (memoizedStory["story-template"]) {
    case "live-blog":
      return (
        <div className="full-width-with-padding separator">
          <LiveBlog story={memoizedStory} cardId={get(params, ["cardId"])} newStory={newStory} />{" "}
        </div>
      );
    case "live-qa":
      setLiveQA(true);
      return (
        <div>
          <LiveQA story={memoizedStory} newStory={newStory} />
        </div>
      )
    case "listicle":
      return (
        <div className="full-width-with-padding separator">
          <Listicle story={memoizedStory} newStory={newStory} />{" "}
        </div>
      );
    case "video":
      return (
        <div className="full-width-with-padding separator">
          {" "}
          <VideoStory story={memoizedStory} newStory={newStory} />{" "}
        </div>
      );
    case "podcast":
      return (
        <div className="full-width-with-padding separator">
          <Podcast story={memoizedStory} newStory={newStory} />{" "}
        </div>
      );
    case "photo":
      return (
        <div className="full-width-with-padding separator">
          <PhotoStory story={memoizedStory} newStory={newStory} />
        </div>
      );
    default:
      return (
        <div className="full-width-with-padding separator">
          <TextSTory story={memoizedStory} newStory={newStory} />
        </div>
      );
  }
}

StoryPageBase.propTypes = {
  index: number,
  story: object,
  otherProp: any,
  params: object
};

function storyPageLoadItems(pageNumber) {
  return global
    .wretch("/api/v1/stories")
    .query({
      fields: storyFields,
      limit: 5,
      offset: 5 * pageNumber
    })
    .get()
    .json(response => response.stories.map(story => ({ story, otherProp: "value" })));
}

export function StoryPage(props) {
  const [liveQA, setLiveQA] = React.useState(false)
  return (
    <>
      <StoryPageBase {...props.data} setLiveQA={setLiveQA}></StoryPageBase>
      {!liveQA?<RelatedStories story={props.data.story} />:null}
      
    </>
  );
}

StoryPage.propTypes = {
  data: shape({
    story: object
  })
};

export const StoryPagePreview = WithPreview(StoryPage, (data, story) =>
  Object.assign({}, data, {
    story,
    relatedStories: Array(5).fill(story)
  })
);
